import { IconBase, type IconProps } from './iconBase';

import type { JSX } from 'react';

export const Open = ({ type, ...rest }: IconProps): JSX.Element => (
  <IconBase viewBox='0 0 24 24' {...rest}>
    {type === 'stroke' ? (
      <path
        d='M9 4.438H7.2c-1.12 0-1.68 0-2.108.218a2 2 0 0 0-.874.874C4 5.958 4 6.518 4 7.638v9.6c0 1.12 0 1.68.218 2.108a2 2 0 0 0 .874.874c.428.218.988.218 2.108.218h9.6c1.12 0 1.68 0 2.108-.218a2 2 0 0 0 .874-.874c.218-.428.218-.988.218-2.108v-1.8m-6-11h6m0 0v6m0-6-9 9'
        stroke='currentColor'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    ) : (
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M7.17 3.688H9a.75.75 0 0 1 0 1.5H7.2c-.572 0-.957 0-1.253.025-.287.023-.424.065-.514.111a1.25 1.25 0 0 0-.547.547c-.046.09-.088.227-.111.514-.024.296-.025.68-.025 1.253v9.6c0 .572 0 .957.025 1.253.023.287.065.424.111.515.12.235.311.426.547.546.09.046.227.088.514.111.296.024.68.025 1.253.025h9.6c.572 0 .957 0 1.252-.025.288-.023.425-.065.515-.111a1.25 1.25 0 0 0 .547-.546c.046-.091.088-.228.111-.515.024-.296.025-.68.025-1.253v-1.8a.75.75 0 0 1 1.5 0v1.83c0 .535 0 .98-.03 1.345-.03.38-.098.736-.27 1.073a2.75 2.75 0 0 1-1.201 1.202c-.338.172-.694.24-1.074.27-.365.03-.81.03-1.344.03H7.17c-.535 0-.98 0-1.345-.03-.38-.03-.736-.098-1.073-.27a2.75 2.75 0 0 1-1.202-1.202c-.172-.337-.24-.694-.27-1.073-.03-.365-.03-.81-.03-1.345v-9.66c0-.535 0-.98.03-1.345.03-.38.098-.736.27-1.073a2.75 2.75 0 0 1 1.202-1.202c.337-.172.693-.24 1.073-.27.365-.03.81-.03 1.345-.03m6.08.75a.75.75 0 0 1 .75-.75h6a.75.75 0 0 1 .75.75v6a.75.75 0 0 1-1.5 0v-4.19l-7.72 7.72a.75.75 0 1 1-1.06-1.06l7.72-7.72H14a.75.75 0 0 1-.75-.75'
        fill='currentColor'
      />
    )}
  </IconBase>
);
